module.exports = __webpack_public_path__ + "img/retangulo-redondo.1d673621.png";